// Stretches of a feature over which a set of tags is constant, the same cut the
// map's styleBySection makes, so a view's tables line up with what the map draws.
import {
  closeOffsetSections,
  mergeAdjacent,
  resolveSections,
} from "../layers/style/util/stepSections.mjs";
import { axisEndCm } from "./positions.mjs";

/**
 * A tag's value as sections: its LR sections, or one open section from 0 for a
 * whole-way value. Null for an LR key whose value does not parse.
 * @param {{lr: string|null, sections: object[]|null, value: unknown}} tag
 */
export function tagSections(tag) {
  if (tag.lr) return tag.sections;
  if (tag.value === null || tag.value === undefined) return null;
  return [{ startCm: 0, endCm: null, value: String(tag.value) }];
}

/**
 * @param {Record<string, {startCm: number, endCm: number|null, value: string}[]>} sectionsByName
 * @param {number|null} lengthCm
 * @returns {{startCm: number, endCm: number, values: Record<string, string|undefined>}[]}
 *   adjacent identical stretches merged, stretches where nothing is tagged dropped
 */
export function buildStretches(sectionsByName, lengthCm) {
  const end = axisEndCm(lengthCm, Object.values(sectionsByName).flat());
  const closed = Object.fromEntries(
    Object.entries(sectionsByName).map(([name, sections]) => [
      name,
      closeOffsetSections(sections),
    ]),
  );
  return mergeAdjacent(resolveSections(closed, end), (interval) =>
    JSON.stringify(interval.values),
  )
    .filter((s) => Object.values(s.values).some((v) => v !== undefined))
    .map(({ startCm, endCm, values }) => ({ startCm, endCm, values }));
}
